"use client";

import { useTranslations } from "next-intl";

import { FftAlert } from "./fft-alert";

export interface FftMarketClosedAlertProps {
  /** Pre-lock the warning is about the lock countdown, not unusable credits. */
  preLock?: boolean;
}

export function FftMarketClosedAlert({ preLock = false }: FftMarketClosedAlertProps) {
  const t = useTranslations("firstTradeOnUs");

  return (
    <FftAlert
      title={t("marketClosedTitle")}
      body={preLock ? t("marketClosedBodyPreLock") : t("marketClosedBody")}
      data-testid="fft-market-closed-alert"
    />
  );
}
